export const navsInit = [
  { title: "首页", path: "/home", name: "home", icon: "&#xe673;" },
  // { title: "审批云", path: "/approveCloud", name: "approveCloud", icon: "&#xe673;", isHide: true },
  { title: "预算云", path: "/budgetCloud", name: "budgetCloud", icon: "&#xe671;", isHide: true },
  { title: "财务云", path: "/financialCloud", name: "financialCloud", icon: "&#xe674;", isHide: true },
  { title: "进销存", path: "/InvoicingIndex", name: "InvoicingIndex", icon: "&#xe672;", isHide: true },
  { title: "财务报表", path: "/financialStatements", name: "financialStatements", icon: "&#xe670;", isHide: true },
  { title: "财税分析", path: "/fiscalTaxAnalysis", name: "fiscalTaxAnalysis", icon: "&#xe66f;", isHide: true },
  { title: "企业信息", path: "/enterpriseInformation", name: "enterpriseInformation", icon: "&#xe66e;", isHide: true },
];
export const navsInitCustomerManage = [
  { title: "签约客户", code: 100100, path: "/signedCustomer", name: "signedCustomer", icon: "&#xe727;", isHide: false },
  { title: "解约客户", code: 100203, path: "/unsignedCustomer", name: "unsignedCustomer", icon: "&#xe728;", isHide: false },
];

export const getNavsInit = () => JSON.parse(JSON.stringify(navsInit));
export const getNavsInitCustomerManage = () => JSON.parse(JSON.stringify(navsInitCustomerManage));
